import { Role } from "../../../helpers/role";
export const InventoryMenu = [
  {
    title: "Home",
    icon: "mdi-view-dashboard",
    to: "",
    code: "dashboard",
    role: [Role.Inventory],
  },

  {
    title: "Seach",
    icon: "mdi-magnify",
    to: "search",
    code: "dashboard",
    role: [Role.Inventory],
  },

  {
    title: "List",
    icon: "mdi-format-list-checks",
    role: [Role.Inventory],
    code: "list",
    submenu: [
      {
        title: "On Hand",
        icon: "mdi-hand-coin-outline",
        to: "onhand",
        code: "onhand",
        role: [Role.Inventory],
      },
      {
        title: "Released",
        icon: "mdi-arrow-up-bold-outline",
        to: "released",
        code: "released",
        role: [Role.Inventory],
      },
      {
        title: "Activated",
        icon: "mdi-check-circle-outline",
        to: "activated",
        code: "activated",
        role: [Role.Inventory],
      },
      {
        title: "Defective",
        icon: "mdi-alert-outline",
        to: "defective",
        code: "defective",
        role: [Role.Inventory],
      },
      {
        title: "Returned to WH",
        icon: "mdi-arrow-down-bold-outline",
        to: "returned",
        code: "returned",
        role: [Role.Inventory],
      },
      {
        title: "Registered",
        icon: "mdi-registered-trademark",
        to: "registered",
        code: "registered",
        role: [Role.Inventory],
      },
    ],
  },
];
